import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home" },
  { to: "/wintv", label: "WinTV" },
  { to: "/earth", label: "Earth Innovation" },
  { to: "/ai-council", label: "AI Council" },
  { to: "/world-ai", label: "World AI" },
  { to: "/blog", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-nav" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <span className="inline-flex w-9 h-9 items-center justify-center rounded-full bg-ink text-white font-display font-semibold">W</span>
          <span className="font-display text-lg tracking-tight">
            WinWorld <span className="text-gold">Innovation</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide link-underline ${isActive ? "text-ink font-medium" : "text-ink/70 hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/members" data-testid="cta-members" className="text-sm px-4 py-2 rounded-full btn-outline-ink">
            Members
          </Link>
          <Link to="/agents" data-testid="cta-agents" className="text-sm px-4 py-2 rounded-full btn-gold font-medium">
            AI Agents
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-ink"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-ink/10 bg-white" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-1 text-base ${isActive ? "text-ink font-medium" : "text-ink/70"}`
                }
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex gap-3 pt-2">
              <Link to="/members" onClick={() => setOpen(false)} className="flex-1 text-center text-sm px-4 py-2 rounded-full btn-outline-ink">Members</Link>
              <Link to="/agents" onClick={() => setOpen(false)} className="flex-1 text-center text-sm px-4 py-2 rounded-full btn-gold font-medium">AI Agents</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
